
import { get } from "lodash-es";
import Blue from "~/core";

new Blue(
    {
        name: "CareerSearchResults",
        selector: ".aviation-career-search",
        setup(careerSearch) {

            const emptyCompareTileTemplate = 'Select a career to compare';
            const compareButtonUnselectedTemplate = 'ADD TO COMPARE';
            const compareButtonSelectedTemplate = 'ADDED';

            const careerSearchResetFormButton = careerSearch.querySelector('button[type="reset"]');
            const careerSearchListItems = careerSearch.querySelector('.aviation-career-search__results');
            const keywordSearchInput = careerSearch.querySelector("#search");
            const careerSearchSortByDropdown = careerSearch.querySelector(".aviation-career-search__results-sort .aviation-career-search__input");
            const careerSearchCompareButtons = careerSearch.querySelectorAll(".aviation-career-search__result-card-footer button.aviation-career-search__button");
            const compareToolbarContainer = document.querySelector(".aviation-career-search__tray");
    
            window.onload = function() {
                const selectedCareers = getLatestSelectedCareersFromCookie();
                
                clearAllCareersFromCompareList(false);

                selectedCareers.forEach(careerGuid => {

                    const careerCardCompareButton = document.querySelector(`.aviation-career-search__result-card-footer button.aviation-career-search__button[data-careerguid="${careerGuid}"]`);

                    if (careerCardCompareButton) {
                        AddCareerToCompareList(careerCardCompareButton);
                    }
                });
            }

            careerSearchResetFormButton.addEventListener('click', (e) => {
                e.preventDefault();
                resetCareerSearchForm();
            });


            if(careerSearchSortByDropdown){
                careerSearchSortByDropdown.addEventListener('change', (e) => {
                    sortResultList(e);
                });
            }

            if(careerSearchCompareButtons){
                careerSearchCompareButtons.forEach(element => {
                    element.addEventListener('click', (e) => {
                        AddCareerToCompareList(e.currentTarget);
                    });
                });
            }
            
            function getLatestSelectedCareersFromCookie() {
                const careersForComparison = decodeURIComponent(document.cookie.replace(/(?:(?:^|.*;\s*)CareersForComparison\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
                return careersForComparison.split(",").filter(careerGuid => careerGuid !== "");
            }

            function AddCareerToCompareList(compareButtonSource) {

                if(compareButtonSource.querySelector("span").innerText == compareButtonSelectedTemplate) {
                    return;
                }

                let compareToolbarUnselected = document.querySelectorAll(".aviation-career-search__tray-comparo-item.is-empty");

                if(compareToolbarContainer.style.display == "") {
                    compareToolbarContainer.style.display = "flex";
                }

                if(compareToolbarUnselected.length == 0){
                    document.querySelector(".aviation-career-search__tray-error").hidden = false;
                }
                else {
                    var careerTitle = compareButtonSource.dataset.careertitle;
                    var careerGuid = compareButtonSource.dataset.careerguid;
                    compareToolbarUnselected[0].querySelector("p").innerText = careerTitle;
                    compareToolbarUnselected[0].querySelector(".aviation-career-search__tray-comparo-item-remove").style.display = "flex";
                    compareToolbarUnselected[0].querySelector(".aviation-career-search__tray-comparo-item-remove svg.bi-x-circle-fill").style.display = "flex";
                    compareToolbarUnselected[0].dataset.careerguid = careerGuid;
                    compareToolbarUnselected[0].classList.remove("is-empty");

                    compareButtonSource.querySelector("span").innerText = compareButtonSelectedTemplate;
                    compareButtonSource.querySelector("svg.bi-plus-circle-fill").style.display = "none";
                    compareButtonSource.querySelector("svg.bi-check-circle").style.display = "flex";

                    
                    updateCareersForComparisonCookie();

                    setupClearButtonEventListeners();
                }
            }

            function setupClearButtonEventListeners() {
                var clearSingleCareerButtons = document.querySelectorAll(".aviation-career-search__tray-comparo-item-remove");
                clearSingleCareerButtons.forEach(element => {
                    element.addEventListener('click', (e) => {
                        clearSingleCareerFromCompareList(e);
                    });
                });

                var clearAllCareersButton = document.querySelector(".aviation-career-search__tray .aviation-career-search__button.aviation-career-search__button--outline");                
                clearAllCareersButton.addEventListener('click', (e) => {
                    clearAllCareersFromCompareList(true);
                });
            }

            function clearAllCareersFromCompareList(shouldUpdateCareersForComparisonCookie) {
                var compareToolbarTiles = document.querySelectorAll(".aviation-career-search__tray-comparo-item");
                var compareButtons = document.querySelectorAll(".aviation-career-search__result-card-footer button.aviation-career-search__button");

                compareToolbarTiles.forEach(element => {
                    element.querySelector("p").innerText = emptyCompareTileTemplate;
                    element.querySelector(".aviation-career-search__tray-comparo-item-remove").style.display = "none";
                    element.querySelector(".aviation-career-search__tray-comparo-item-remove svg.bi-x-circle-fill").style.display = "none";
                    element.classList.add("is-empty");
                });

                compareButtons.forEach(element => {
                    element.querySelector("svg.bi-plus-circle-fill").style.display="flex";
                    element.querySelector("svg.bi-check-circle").style.display="none";
                    element.querySelector("span").innerText = compareButtonUnselectedTemplate;
                });

                compareToolbarContainer.style.display = "";

                if (shouldUpdateCareersForComparisonCookie){
                    updateCareersForComparisonCookie();
                }
            }

            function clearSingleCareerFromCompareList(e){
                var clearSingleCareerButton = e.currentTarget;
                var compareToolbarTile = clearSingleCareerButton.parentElement;
                var compareButtonSource = document.querySelector(`.aviation-career-search__result-card-footer button.aviation-career-search__button[data-careertitle="${compareToolbarTile.innerText}"]`);

                var compareToolbarMaxSelectedError = document.querySelector(".aviation-career-search__tray-error");

                compareToolbarMaxSelectedError.hidden = true;

                compareToolbarTile.querySelector("p").innerText = emptyCompareTileTemplate;
                clearSingleCareerButton.style.display = "none";
                clearSingleCareerButton.querySelector("svg.bi-x-circle-fill").style.display = "none";

                compareToolbarTile.dataset.careerguid = "";
                compareToolbarTile.classList.add("is-empty");

                compareButtonSource.querySelector("span").innerText = compareButtonUnselectedTemplate;
                compareButtonSource.querySelector("svg.bi-plus-circle-fill").style.display="flex";
                compareButtonSource.querySelector("svg.bi-check-circle").style.display="none";

                updateCareersForComparisonCookie();

                var compareToolbarUnselected = document.querySelectorAll(".aviation-career-search__tray-comparo-item.is-empty");

                if(compareToolbarUnselected.length == 3) {
                    compareToolbarContainer.style.display = "";
                }
            }

            function sortResultList(e){                
                var dataObject = {
                    selectedSortField: careerSearchSortByDropdown.value,
                    resultItems: resultItems
                };
                
                fetch('api/career-search/sort-results', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(dataObject)
                })
                .then(response => response.text())
                .then(data => {
                    careerSearchListItems.innerHTML = data;
                })
                .catch(error => {
                    console.error(`Error: ${error}`);
                });
            }
        
            function resetCareerSearchForm(){

                careerSearch.querySelector(".aviation-career-search__results-filters").style.display = "none";

                careerSearchListItems.replaceChildren();

                keywordSearchInput.value = "";                
                
                var cleanedUrl = window.location.href.replace(location.search, "");

                window.history.pushState("", "", cleanedUrl);
            }

            function updateCareersForComparisonCookie() {
                var careersForComparison = '';
            
                document.querySelectorAll(".aviation-career-search__tray-comparo-item:not(.is-empty)").forEach(element => {
                    careersForComparison += `${element.dataset.careerguid},`;
                });
            
                careersForComparison = encodeURIComponent(careersForComparison);
            
                document.cookie = `CareersForComparison=${careersForComparison};  path=/`;
            }
        }
    }
)